import { Modal, ModalProps, Select } from 'antd'
import VSpace from '../common/VSpace'
import { ItemVisitData, ItemWorkareaData } from './itemModel'
import { useState } from 'react'

export type Props = {
  open: boolean
  workareas: ItemWorkareaData[]
  visitData: ItemVisitData[]
  onSelect: (workareaId: number, visitId: string) => void
  onCancel: () => void
} & Pick<ModalProps, 'getContainer'>

const WorkareaAndVisitSelectionModal = ({ open, workareas, visitData, onSelect, onCancel, getContainer }: Props) => {
  const [selectedWorkareaId, setSelectedWorkareaId] = useState<number | undefined>()
  const [selectedVisitId, setSelectedVisitId] = useState<string | undefined>()

  const formatDate = (date: string): string => {
    return new Date(date).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })
  }

  return <Modal
    title="Select Workarea & Visit"
    open={open}
    okText="Add Item"
    okButtonProps={{
      disabled: selectedWorkareaId === undefined || selectedVisitId === undefined
    }}
    onOk={() => onSelect(selectedWorkareaId!, selectedVisitId!)}
    onCancel={onCancel}
    getContainer={getContainer}
  >
    <VSpace>
      <label>Which workarea and visit should this item be added to?</label>
      <Select
        placeholder="Select workarea..."
        options={workareas.filter(x => !x.isOnHold).map(x => ({ label: x.name, value: x.id }))}
        style={{ width: '100%' }}
        onChange={setSelectedWorkareaId}
      />
      <Select
        placeholder="Select non-reviewed visit..."
        options={visitData.filter(x => !x.billed).map(x => ({ label: formatDate(x.date), value: x.id }))}
        style={{ width: '100%' }}
        onChange={setSelectedVisitId}
      />
    </VSpace>
  </Modal>
}
export default WorkareaAndVisitSelectionModal
